<!--结算-->
<template>
    <el-dialog
            title="结算"
            :visible="true"
            width="23%"
            :before-close="handleClose">
        <el-form ref="form" :model="form"  label-width="120px">
            <div class="title">
                <p>结算经销商</p>
            </div>
            <el-form-item label="经销商编号:">
                <span>{{prop.dealer_sn}}</span>
            </el-form-item>
            <el-form-item label="经销商名称:">
                <span>{{prop.dealer_name}}</span>
            </el-form-item>
            <el-form-item label="经销商级别:">
                <span>{{prop.dealer_name}}</span>
            </el-form-item>
            <el-form-item label="上级经销商:">
                <span>{{prop.dealer_level_name}}</span>
            </el-form-item>
            <el-form-item label="返利金额:">
                <span style="color: red">{{prop.total_rebate}}</span>
            </el-form-item>
               <el-form-item label="账户余额:">
                <span style="color: red">{{prop.account_balance}}</span>
            </el-form-item>
            <div class="title">
                <p>结算</p>
            </div>
            <el-form-item label="结算金额:" style="margin-top: 10px">
                <el-col :span="16">
                    <el-input v-model="form.settlement_money" clearable></el-input>
                </el-col>

            </el-form-item>
            <el-form-item label="备注:">
                <el-col :span="16">
                    <el-input type="textarea" v-model="form.remarks"></el-input>
                </el-col>
                <el-col :span="8" style="margin-top: 20px;">
                    <span>(限50字以内)</span>
                </el-col>
            </el-form-item>
        </el-form>
         <span slot="footer" class="dialog-footer">
    <el-button @click="handleClose">取 消</el-button>
    <el-button type="primary" @click="confrim">确 定</el-button>
  </span>
    </el-dialog>
</template>

<script>
    export default {
        name: "settlement-dialog",
        data() {
            return {
                form:{
                   
                    remarks:'',
                    settlement_money:''
                }
            }
        },
        props:{
            prop:Object
        },
        methods: {
            handleClose() {
                this.$emit('handleClose');
            },
            confrim(){
                if(this.form.settlement_money==''){
                     this.$message({
                        type:'error',
                        message:'结算金额不能为空'
                    })
                    return
                }
                if(parseFloat(this.form.settlement_money)>parseFloat(this.prop.account_balance) || parseFloat(this.form.settlement_money)<0.01){
                    this.$message({
                        type:'error',
                        message:'结算金额最大不能超过返利金额,最小不能低与0.01元'
                    })
                    return;
                }
                this.$emit('pushData',{
                    ...this.form,
                    dealer_sn:this.prop.dealer_sn
                })
                this.handleClose()
            }
        },
        created() {
            console.log(this.prop)
        },
    }
</script>

<style lang="scss" scoped>
    .title{
        border-bottom: 1px solid #ccc;
        font-size: 16px;
        color: black;
        padding: 10px;
    }

</style>